// extracted by mini-css-extract-plugin
export var htmlPreview = "_r5-2";
export var modal = "_r5-0";
export var sidebar = "_r5-1";